import { Helmet } from 'react-helmet';

import { AdministratorPricesIndexsList } from 'components/templates';

const AdministratorPricesIndexsListPage = () => (
    <>
        <Helmet>
            <title>Preços de Índices - Painel Administrador - Imobiler</title>
        </Helmet>

        <AdministratorPricesIndexsList />
    </>
);

export default AdministratorPricesIndexsListPage;
